import { AxiosResponse } from 'axios';

export const genericTransformer = <T>(response: AxiosResponse<T>): T => response?.data;
